import GetRequest from "../components/apiConnections/getRequest";
import PostRequest from "../components/apiConnections/postRequest";

export const GetSubscriptionDetails = async () => {
    let resObj = { error: true, message: "unable to get subscriptions " }
    try {
        const refreshToken = await PostRequest(
            `${process.env.REACT_APP_BACKEND_BASE_URL}${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_REFRESH_TOKEN}`,
            {},
            {},
            "refreshToken"
        );
        if (refreshToken) {
            await GetRequest(
                `${process.env.REACT_APP_BACKEND_BASE_URL}${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_GET_CLIENT_SUBSCRIPTION_DETAIL}`,
                {}
            )
                .then((res) => {
                    let data = res.data.data;
                    resObj = { error: false, message: null, data: data }
                })
                .catch((err) => {
                    resObj = { error: true, message: err.data?.message || err.message }
                })
        }
    }
    catch (error) {
        console.log(error)
    }
    return resObj;
}





